import { LwApiPM } from "@techniaorg/liteweb-api";
import { waitForIFrameAndModel } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrameAndModel(myframe)
  .then((api) => {
    LwAPI = api;
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

function ex_setview(v: number) {
  LwAPI?.setView(v);
}

// Bind functions to buttons
document.getElementById("set0")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(0);
});
document.getElementById("set1")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(1);
});
document.getElementById("set2")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(2);
});
document.getElementById("set3")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(3);
});
document.getElementById("set4")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(4);
});
document.getElementById("set5")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(5);
});
document.getElementById("set6")?.addEventListener("click", async () => {
  await apiReady;
  ex_setview(6);
});
